import SpotahomeGuaranteeModal from './SpotahomeGuaranteeModal';

export default SpotahomeGuaranteeModal;
